import { render } from "./SampleProjectsView.vue?vue&type=template&id=2aa0921a"
import script from "./SampleProjectsView.vue?vue&type=script&lang=js"
export * from "./SampleProjectsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__